import axiosInstance from "./axiosInstance";

/**
 * Get resume data by userId
 */
export const getResumeData = async (userId) => {
  if (!userId) throw new Error("User ID is required");

  const res = await axiosInstance.post(
    "/opencase/get",
    { userId },
    { withCredentials: true }
  );

  return res.data;
};

/**
 * Save / Update resume basic info
 */
export const saveResumeData = async (payload) => {
  if (!payload?.userId) throw new Error("User ID is required");

  const res = await axiosInstance.post(
    "/opencase/put",
    payload,
    { withCredentials: true }
  );
  console.log(res.data)

  return res.data;
};

/**
 * Upload resume profile image
 */
export const uploadResumeImage = async (userId, imageFile) => {
  if (!userId || !imageFile)
    throw new Error("User ID and image file are required");

  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("image", imageFile);

  const res = await axiosInstance.post(
    "/opencase/putImage",
    formData,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};
